export const validatePhoneNumber = (phoneNumber: string) => {
  const re = /^\+[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/;
  return re.test(phoneNumber.trim()) ? true : "Please enter phone number";
}
